import { render, staticRenderFns } from "./BuyerSidebar.vue?vue&type=template&id=25c7e5ee&scoped=true&"
import script from "./BuyerSidebar.vue?vue&type=script&lang=js&"
export * from "./BuyerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7e5ee",
  null
  
)

export default component.exports